import React from 'react';
import clsx from 'clsx';
import BaseButton from '@/components/Form/Buttons/BaseButton';

const PrimaryButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (
  props,
) => {
  return (
    <BaseButton
      {...props}
      className={clsx('bg-primary text-gray', props.className)}
    />
  );
};

export default PrimaryButton;
